import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-75" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-76" data-mp="9t1nh6wuedbj">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary bg-background p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-77" data-mp="etpmaerbbygb">
          <span className="inline-flex rounded-full border border-accent/60 bg-surface p-4 text-accent" data-id="element-78" data-mp="sn6ux4ignqrk">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-79" data-mp="xlrzth8nqymc" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-80" data-mp="12gxje9el8179">
            7-Day <span className="text-accent" data-id="element-81" data-mp="25sghnddhe60c">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-82" data-mp="25pkl9tha7pe0">
            Study all 6 volumes and 5 bonuses in your specific chemistry focus area this week. If the technical depth
            doesn't match your professional needs or materials don't enhance your capability,{' '}
            <span className="font-extrabold text-accent" data-id="element-83" data-mp="1ru8prjvaxuw1">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}